module.exports = __webpack_public_path__ + "static/img/SMBE.72bbc18d.png";